import { createRouter, createWebHashHistory } from 'vue-router'
import { authGuard } from '@auth0/auth0-vue'
import NProgress from 'nprogress/nprogress.js'

// Main layout variations
import LayoutSimple from '@/layouts/variations/LayoutSimple.vue'

// Publinker Layouts
import PublinkerBackend from '@/layouts/variations/PublinkerBackend.vue'
//Wrapper manual
const PublinkerWrapperManual = () =>
  import('@/views/backend/PublinkerWrapperManualView.vue')
// Publinker Ranking
const PublinkerRanking = () =>
  import('@/views/backend/PublinkerRankingView.vue')
// Publinker Profile
const PublinkerProfile = () =>
  import('@/views/backend/PublinkerProfileView.vue')
// Frontend: Landing
const PublinkerLanding = () =>
  import('@/views/landing/PublinkerLandingView.vue')

// Publinker: Dashboard
const PublinkerDashboard = () =>
  import('@/views/backend/PublinkerDashboardView.vue')

// Publinker: Pricing
const PublinkerPricing = () =>
  import('@/views/backend/PublinkerPricingView.vue')

// Publinker: Pricing History
const PublinkerPricingHistory = () =>
  import('@/views/backend/PublinkerPricingHistoryView.vue')

// Publinker: Pricing Limits
const PublinkerPricingLimits = () =>
  import('@/views/backend/PublinkerPricingLimitsView.vue')

// Publinker: Lead Clump - Account
const LeadClumpAccount = () =>
  import('@/views/backend/leadclump/AccountView.vue')

// Publinker: Lead Clump - Quiz
const LeadClumpQuiz = () => import('@/views/backend/leadclump/QuizView.vue')

// Publinker: Lead Clump - Weight
const LeadClumpWeight = () => import('@/views/backend/leadclump/WeightView.vue')

// Publinker: Lead Clump - Email Checker
const LeadClumpEmailChecker = () =>
  import('@/views/backend/leadclump/EmailCheckerView.vue')

// Publinker: Dimension Group
const PublinkerDimensionGroup = () =>
  import('@/views/backend/PublinkerDimensionGroupView.vue')

// Publinker: Url Types
const PublinkerUrlTypes = () =>
  import('@/views/backend/PublinkerUrlTypeView.vue')

// Publinker: Config
const PublinkerConfig = () => import('@/views/backend/PublinkerConfigView.vue')

const PublinkerConfigHistory = () =>
  import('@/views/backend/PublinkerConfigHistoryView.vue')

const PublinkerActiveCampaignConfig = () =>
  import('@/views/backend/PublinkerActiveCampaignConfigView.vue')
// Publinker: Facebook Ads Views
const PublinkerFacebookAdsConfig = () =>
  import('@/views/backend/PublinkerFacebookAdsConfigView.vue')

const PublinkerFacebookAdsCampaign = () =>
  import('@/views/backend/PublinkerFacebookAdsCampaignView.vue')

const PublinkerFacebookAdsAccount = () =>
  import('@/views/backend/PublinkerFacebookAdsAccountView.vue')
// Publinker: Google Ads Views
const PublinkerGoogleAdsConfig = () =>
  import('@/views/backend/PublinkerGoogleAdsConfigView.vue')

const PublinkerGoogleAdsCampaign = () =>
  import('@/views/backend/PublinkerGoogleAdsCampaignView.vue')

const PublinkerGoogleAdsAccount = () =>
  import('@/views/backend/PublinkerGoogleAdsConfigView.vue')

const PublinkerGoogleAdmReport = () =>
  import('@/views/backend/PublinkerGoogleAdmReportsView.vue')

const PublinkerAdspeedGam = () =>
  import('@/views/backend/PublinkerAdspeedGamView.vue')

const PublinkerAdspeedGamAdunit = () =>
  import('@/views/backend/PublinkerAdspeedGamAdunitView.vue')

const PublinkerActiveCampaignAccounts = () =>
  import('@/views/backend/PublinkerActiveCampaignAccountsView.vue')

const PublinkerActiveCampaign = () =>
  import('@/views/backend/PublinkerActiveCampaignAccountSelectView.vue')

const PublinkerCheckoutView = () =>
  import('@/views/backend/PublinkerCheckoutView.vue')

const PublinkerBillingView = () =>
  import('@/views/backend/PublinkerBillingView.vue')

const PublinkerEscalatedReportView = () =>
  import('@/views/backend/PublinkerEscalatedReportView.vue')
// Publinker Admin: User
const PublinkerOverwatchUser = () =>
  import('@/views/backend/PublinkerOverwatchUserView.vue')

// Publinker Admin: Company
const PublinkerOverwatchCompany = () =>
  import('@/views/backend/PublinkerOverwatchCompanyView.vue')

// Publinker Admin: Site
const PublinkerOverwatchSite = () =>
  import('@/views/backend/PublinkerOverwatchSiteView.vue')

// Publinker Admin: Jobs
const PublinkerOverwatchJobs = () =>
  import('@/views/backend/PublinkerOverwatchJobsView.vue')

const PublinkerPostmaster = () =>
  import('@/views/backend/PublinkerPostmasterView.vue')

const PublinkerPostmasterConfig = () =>
  import('@/views/backend/PublinkerPostmasterConfigView.vue')

// Publinker: Leads Overview
const PublinkerLeadsView = () =>
  import('@/views/backend/PublinkerLeadsView.vue')

// Publinker: Release Notes
const PublinkerReleaseNotes = () =>
  import('@/views/backend/PublinkerReleaseNotesView.vue')

const PublinkerKvpUtm = () => import('@/views/backend/PublinkerKvpUtmView.vue')

// Set all routes
const routes = [
  /*
  |
  |--------------------------------------------------------------------------
  | Landing Routes
  |--------------------------------------------------------------------------
  |
  */
  {
    path: '/',
    component: LayoutSimple,
    children: [
      {
        path: '',
        name: 'landing',
        component: PublinkerLanding
      }
    ]
  },

  /*
  |
  |--------------------------------------------------------------------------
  | Publinker Routes
  |--------------------------------------------------------------------------
  |
  */
  {
    path: '/:site?',
    component: PublinkerBackend,
    children: [
      {
        path: 'pricing',
        name: 'pricing',
        component: PublinkerPricing
      },
      {
        path: 'pricing-history',
        name: 'pricing-history',
        component: PublinkerPricingHistory
      },
      {
        path: 'pricing-limits',
        name: 'pricing-limits',
        component: PublinkerPricingLimits
      },
      {
        path: 'lead-clump-account',
        name: 'lead-clump-account',
        component: LeadClumpAccount
      },
      {
        path: 'lead-clump-quiz',
        name: 'lead-clump-quiz',
        component: LeadClumpQuiz
      },
      {
        path: 'lead-clump-weight',
        name: 'lead-clump-weight',
        component: LeadClumpWeight
      },
      {
        path: 'lead-clump-email-checker',
        name: 'lead-clump-email-checker',
        component: LeadClumpEmailChecker
      },
      {
        path: 'dimension-group',
        name: 'dimension-group',
        component: PublinkerDimensionGroup
      },
      {
        path: 'url-type',
        name: 'url-type',
        component: PublinkerUrlTypes
      },
      {
        path: 'config',
        name: 'config',
        component: PublinkerConfig
      },
      {
        path: 'config-history',
        name: 'config-history',
        component: PublinkerConfigHistory
      },
      {
        path: 'facebook-ads/config',
        name: 'facebook-ads-config',
        component: PublinkerFacebookAdsConfig
      },
      {
        path: 'facebook-ads/campaign',
        name: 'facebook-ads-campaign',
        component: PublinkerFacebookAdsCampaign
      },
      {
        path: 'facebook-ads/account',
        name: 'facebook-ads-account',
        component: PublinkerFacebookAdsAccount
      },
      {
        path: 'google-ads/config',
        name: 'google-ads-config',
        component: PublinkerGoogleAdsConfig
      },
      {
        path: 'google-ads/campaign',
        name: 'google-ads-campaign',
        component: PublinkerGoogleAdsCampaign
      },
      {
        path: 'google-ads/account',
        name: 'google-ads-account',
        component: PublinkerGoogleAdsAccount
      },
      {
        path: 'google-adm/reports',
        name: 'google-adm-reports',
        component: PublinkerGoogleAdmReport
      },
      {
        path: 'google-adm/adspeed',
        name: 'google-adm-adspeed',
        component: PublinkerAdspeedGam
      },
      {
        path: 'google-adm/adspeed-adunit',
        name: 'google-adm-adspeed-adunit',
        component: PublinkerAdspeedGamAdunit
      },
      {
        path: 'active-campaign/config',
        name: 'active-campaign-config',
        component: PublinkerActiveCampaignConfig
      },
      {
        path: 'active-campaign/accounts',
        name: 'active-campaign-accounts',
        component: PublinkerActiveCampaignAccounts
      },

      {
        path: 'active-campaign/campaigns',
        name: 'active-campaign-campaigns',
        component: PublinkerActiveCampaign
      },

      {
        path: 'ranking',
        name: 'ranking',
        component: PublinkerRanking
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: PublinkerDashboard
      },
      {
        path: 'release-notes',
        name: 'release-notes',
        component: PublinkerReleaseNotes
      },
      {
        path: 'postmaster',
        name: 'postmaster',
        component: PublinkerPostmaster
      },

      {
        path: 'postmaster/config',
        name: 'postmaster-config',
        component: PublinkerPostmasterConfig
      },
      {
        path: 'wrapper',
        name: 'wrapper',
        component: PublinkerWrapperManual
      },
      {
        path: 'ivt',
        name: 'ivt-report',
        component: PublinkerEscalatedReportView
      },
      {
        path: 'kvp-utm',
        name: 'kvp-utm',
        component: PublinkerKvpUtm
      },
      {
        path: 'leads-overview',
        name: 'leads-overview',
        component: PublinkerLeadsView
      }
    ],

    beforeEnter: authGuard
  },

  {
    path: '/',
    component: PublinkerBackend,
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: PublinkerProfile
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: PublinkerCheckoutView
      },
      {
        path: 'billing',
        name: 'billing',
        component: PublinkerBillingView
      },
      {
        path: 'site/:site/escalated',
        name: 'escalated',
        component: PublinkerEscalatedReportView
      }
    ],
    beforeEnter: authGuard
  },

  /*
  |
  |--------------------------------------------------------------------------
  | Publinker Admin Routes
  |--------------------------------------------------------------------------
  |
  */
  {
    path: '/overwatch',
    component: PublinkerBackend,
    children: [
      {
        path: 'user',
        name: 'user',
        component: PublinkerOverwatchUser
      },
      {
        path: 'company',
        name: 'company',
        component: PublinkerOverwatchCompany
      },
      {
        path: 'site',
        name: 'site',
        component: PublinkerOverwatchSite
      },
      {
        path: 'jobs',
        name: 'jobs',
        component: PublinkerOverwatchJobs
      }
    ],
    beforeEnter: authGuard
  },
  {
    path: '/:site?/:pathMatch(.*)*',
    redirect: to => {
      const site = to.params.site
      if (to.path.includes('release-notes')) {
        return to.path
      }
      return site ? `/${site}/pricing` : '/'
    }
  },
  {
    path: '/:site?/',
    redirect: to => {
      const site = to.params.site
      return site ? `/${site}/pricing` : '/'
    }
  }
]

// Create Router
const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  routes
})

// NProgress

NProgress.configure({ showSpinner: false })

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }

  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
